import type { PublicationBlock } from "../../types";
import { Tag } from "../ui/Tag";
import { assetUrl, siteUrl } from "../../wordpress";

/** Bloco de livro: fundo colorido, capa flutuante e ficha no rodapé. */
export function PublicationBlockCard({ block }: { block: PublicationBlock }) {
	return (
		<a className="block-link" href={siteUrl(block.href)}>
			<article
				className="block block--publication"
				style={{ background: block.color }}
			>
				{block.tag && <Tag>{block.tag}</Tag>}
				<figure className="block__figure">
					<img src={assetUrl(block.cover)} alt={block.title} loading="lazy" />
				</figure>
				<div className="block__content">
					<h3>{block.title}</h3>
					<p className="block__description">{block.description}</p>
					<p className="block__meta">
						<span className="underline">{block.category}</span> / {block.genre}
					</p>
				</div>
			</article>
		</a>
	);
}
